// extracted by mini-css-extract-plugin
export var card = "_7y-0";
export var failedIcon = "_7y-4";
export var failedIconBadge = "_7y-3";
export var icon = "_7y-1";
export var successIcon = "_7y-2";